import { css, type Theme } from "@emotion/react";

import { animations } from "@styles";

export const dropdownSearch = (theme: Theme) => css`
  min-width: 17rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: 1px solid ${theme.separator.base};
  margin-right: -0.5rem;
  margin-left: -0.5rem;
  margin-top: -0.5rem;
  margin-bottom: 0.5rem;

  &:focus-within {
    box-shadow: none;
  }
`;

export const input = {
  base: (theme: Theme) => css`
    border: none;
    transition: color 0.2s ${animations.easeOutQuad};
    background-color: transparent;

    ::placeholder {
      color: ${theme.text.body};
    }

    &:active,
    &:focus {
      border: none;
      box-shadow: none;
    }
  `,
  fullWidth: css`
    width: 100%;
  `,
};
